import React from "react";
import { Link } from "react-router-dom";
import Datatables from "../../components/Datatables/Table";
import TableCell from "../../components/Datatables/TableCell";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faEye } from "@fortawesome/free-solid-svg-icons";
import ViewExpenseModal from "../../components/Expense/viewModal";
function SettleHistory({ loading, data, handleDelete }) {

  const dataHeader = [
    {
        key: "date",
        label: "Date",
     },
    {
    key: "description",
    label: "Description",
    },
    {
      key: "receiverId",
      label: "Receiver Id",
    },
    {
      key: "payerId",
      label: "Payer Id",
    },
    {
      key: "amount",
      label: "Amount",
    },

  ];

  return (
    <Datatables loading={loading} dataHeader={dataHeader}>
      {data?.map((row, index) => (
        <tr
          key={index}
          className="bg-white border md:border-b block md:table-row rounded-md shadow-md md:rounded-none md:shadow-none mb-5"
        >
         <TableCell dataLabel="Date" showLabel={true}>
            <p className="font-normal text-sm text-gray-500">{row.date}</p>
          </TableCell>
          <TableCell dataLabel="Description" showLabel={true}>
            <p className="font-normal text-sm text-gray-500">
              {row.description}
            </p>
          </TableCell>
          <TableCell dataLabel="Reciver Id" showLabel={true}>
            <p className="font-normal text-sm text-gray-500">{row.data.participants[0].userId}</p>
          </TableCell>
          <TableCell dataLabel="Payer Id" showLabel={true}>
            <p className="font-normal text-sm text-gray-500">
              {row.data.paidBy}
            </p>
          </TableCell>
          <TableCell dataLabel="Amount" showLabel={true}>
            <p className="font-normal text-sm text-gray-500"></p>
              <span className="rounded-full py-1 px-3 text-xs font-semibold bg-gray-200 text-emerald-900">
                {row.data.totalAmount}
              </span>
        
          </TableCell>
          
        </tr>
      ))}
       
     
    </Datatables>
  );
}

export default SettleHistory;
